import { AsyncPipe, NgTemplateOutlet } from '@angular/common'
import { Component, inject, OnInit, signal } from '@angular/core'

import { TranslatePipe } from '@ngx-translate/core'
import { Button } from 'primeng/button'
import { Dialog } from 'primeng/dialog'

import { DeviceService } from '@ti/core/common/services'
import { BrandingService } from '@ti/core/common/services/branding.service'
import { ArrowIconComponent } from '@ti/core/icons/arrow'
import { CloseIconComponent } from '@ti/core/icons/close'
import { SafariSymbolIconComponent } from '@ti/core/icons/safari-symbol'

import { LanguageService } from '../../../i18n'
import { ClearBaseUrlPipe } from '../../pipes'

@Component({
  selector: 'app-pwa-install-guide',
  templateUrl: 'pwa-install-guide.component.html',
  styleUrl: 'pwa-install-guide.component.scss',
  imports: [
    Dialog,
    CloseIconComponent,
    NgTemplateOutlet,
    AsyncPipe,
    Button,
    TranslatePipe,
    ClearBaseUrlPipe,
    SafariSymbolIconComponent,
    ArrowIconComponent,
  ],
})
export class PwaInstallGuideComponent implements OnInit {
  protected readonly isOpened = signal(false)
  protected readonly step = signal(1)
  protected readonly languageService = inject(LanguageService)
  protected readonly deviceService = inject(DeviceService)
  protected readonly brandingService = inject(BrandingService)
  protected baseUrl = signal('')

  public ngOnInit() {
    this.initializeBaseUrl()
  }

  public open() {
    this.isOpened.set(true)
  }

  public close() {
    this.isOpened.set(false)
    this.step.set(1)
  }

  protected stepperFunction(stepNumber: number) {
    this.step.set(stepNumber)
  }

  protected initializeBaseUrl() {
    const fullUrl = document.location.href
    const url = new URL(fullUrl)
    this.baseUrl.set(`${url.protocol}//${url.host}/`)
  }
}
